import { render, staticRenderFns } from "./StudentLife.vue?vue&type=template&id=60f9886a"
import script from "./StudentLife.vue?vue&type=script&lang=js"
export * from "./StudentLife.vue?vue&type=script&lang=js"
import style0 from "./StudentLife.vue?vue&type=style&index=0&id=60f9886a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports